/* eslint-disable vue/no-parsing-error */
<template>
  <div class="uploadExample">
    <div class="guide-header">
      <span>为了保证您的举报成功率，请上传真实的资损交易凭证，确保其中的资金信息与填写的一致</span>
    </div>
    <div class="guide-tip">
      <span>如：<br />【<b>支付宝</b>】聊天中的转账记录，或支付宝账单的该交易的明细截图</span>
    </div>
    <div class="guide-tip">
      <span>【微信】聊天转账、红包，或零钱明细中，具体该笔交易的明细截图</span>
    </div>
    <Row class="guide-img" type="flex" justify="space-around">
      <Col span="10">
        <img
          :src="setPicSize('n_v2d11b0db512244a199a043c00836b7510.jpg')"
          @click="showBig(0)"
          width="100%"
          alt="加载中..."
        />
      </Col>
      <Col span="10">
        <img
          :src="setPicSize('n_v23a75db7b700d45d3b61e027f30c0c17c.jpg')"
          @click="showBig(1)"
          width="100%"
          alt="加载中..."
        />
      </Col>
    </Row>
  </div>
</template>

<script>
import { Row, Col, ImagePreview } from '@zz-common/zz-ui'
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
// import { lego } from '@zz-common/lego'
// import { toast } from '../../../native'
import { queryParams } from '../../../lib/utils'

const query = queryParams()

export default {
  name: 'uploadExample',
  data() {
    return {
      from: query.from || this.$route.query.from, //  用户页面是2，商品页面是1，短视频页面是7，私信文字页面是4
      reasonId: query.reasonId || this.$route.query.reasonId,
      beReportedUid: query.bereporteduid || this.$route.query.bereporteduid,
      infoId: query.infoid || this.$route.query.infoid,
      videoId: query.videoId || this.$route.query.videoId,
      imgList: [
        'https://pic1.zhuanstatic.com/zhuanzh/n_v2d11b0db512244a199a043c00836b7510.jpg',
        'https://pic1.zhuanstatic.com/zhuanzh/n_v23a75db7b700d45d3b61e027f30c0c17c.jpg'
      ]
    }
  },
  components: { Col, Row },
  computed: {},
  methods: {
    setPicSize,
    showBig(startPosition) {
      ImagePreview({
        images: this.imgList,
        startPosition,
        adaptApp: true
      })
    },
    closePage() {
      native.close()
    }
  },
  mounted() {
    native.setTitle({
      title: '资损交易凭证'
    })
  },
  beforeRouteEnter(_to, _from, next) {
    next((_vm) => {
      native.wrap('resetRightAllButton')()
    })
  },
  beforeRouteUpdate(to, _from, _next) {
    this.reasonId = to.query.reasonId
  }
}
</script>

<style scoped lang="less">
  @import 'uploadExample.less';
</style>
